export const globalStyles = {
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
